export default {
  root: {
    borderRadius: 0,
    padding: "12px 0",
    "&:hover": {
      backgroundColor: "inherit"
    }
  }
};
